import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { stripRowIds } from 'views/imports/doc-model';
import { filterMarkdownLines } from 'views/imports/row-filter';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    maxHeight: theme.spacing(50),
    overflow: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
  text: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  hint: {
    color: theme.palette.text.secondary,
  },
}));

type MarkdownViewProps = {
  markdown: string;
  filter: string;
};

/** Read-only view of the markdown the assistant receives. Values are edited in the list. */
export const MarkdownView = ({ markdown, filter }: MarkdownViewProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const text = filter.trim() === '' ? stripRowIds(markdown) : filterMarkdownLines(markdown, filter);
  return (
    <section aria-label={t('imports:editor.advanced')} className={classes.root}>
      <Typography variant="caption" display="block" className={classes.hint}>
        {t('imports:editor.advancedHint')}
      </Typography>
      <Typography variant="body2" component="pre" className={classes.text}>
        {text}
      </Typography>
    </section>
  );
};
